import React from 'react';
import { useLang } from '../context/LanguageContext';

export default function AboutPage({ onBook, onDrive }) {
  const { t } = useLang();
  const p = t.aboutPage;

  return (
    <div className="max-w-4xl mx-auto px-6 py-12">

      {/* Hero */}
      <div className="text-center mb-16">
        <span className="inline-block bg-slate-100 text-slate-600 text-xs font-semibold px-3 py-1 rounded-full mb-4">{p.badge}</span>
        <h1 className="text-4xl font-black text-slate-900 mb-4">{p.title}</h1>
        <p className="text-slate-500 text-lg max-w-lg mx-auto leading-relaxed">{p.subtitle}</p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-3 gap-4 mb-16">
        {p.stats.map((s, i) => (
          <div key={i} className="card text-center py-6">
            <div className="text-2xl font-black text-slate-900 mb-1">{s.value}</div>
            <div className="text-xs text-slate-500">{s.label}</div>
          </div>
        ))}
      </div>

      {/* Mission */}
      <div className="bg-slate-50 rounded-3xl p-10 mb-16">
        <h2 className="text-2xl font-black text-slate-900 mb-4">{p.missionTitle}</h2>
        <p className="text-slate-600 leading-relaxed mb-4">{p.mission1}</p>
        <p className="text-slate-600 leading-relaxed">{p.mission2}</p>
      </div>

      {/* Values */}
      <div className="mb-16">
        <h2 className="text-2xl font-black text-slate-900 mb-8 text-center">{p.valuesTitle}</h2>
        <div className="space-y-4">
          {p.values.map((v, i) => (
            <div key={i} className="card flex gap-4 items-start">
              <div className="w-2 h-2 rounded-full bg-primary-500 mt-2 shrink-0" />
              <div>
                <div className="font-bold text-slate-900 mb-1">{v.title}</div>
                <div className="text-sm text-slate-500 leading-relaxed">{v.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Tech */}
      <div className="bg-slate-900 rounded-3xl p-10 mb-16">
        <h2 className="text-2xl font-black text-white mb-4">{p.techTitle}</h2>
        <p className="text-slate-400 leading-relaxed mb-6">{p.techDesc}</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {['Spring Boot 3', 'React', 'PostgreSQL', 'Docker'].map((tech) => (
            <div key={tech} className="bg-slate-800 rounded-xl px-4 py-3 text-center">
              <span className="text-sm font-semibold text-slate-300">{tech}</span>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="text-center">
        <h2 className="text-2xl font-black text-slate-900 mb-3">{p.ctaTitle}</h2>
        <p className="text-slate-500 mb-6">{p.ctaDesc}</p>
        <div className="flex flex-wrap gap-3 justify-center">
          <button onClick={onBook} className="btn-primary text-base px-8 py-3.5">{p.ctaBook}</button>
          <button onClick={onDrive} className="btn-outline text-base px-8 py-3.5">{p.ctaDrive}</button>
        </div>
      </div>
    </div>
  );
}
